var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"menu"},[_c('Header'),(!!_vm.$slots['header'])?_c('div',{staticClass:"sub-header"},[_vm._t("header")],2):_vm._e()],1),_c('div',{staticClass:"content",class:{
    'content--smallheader': (!!_vm.$slots['header'] && _vm.smallHeader),
    'content--mediumheader': (!!_vm.$slots['header'] && _vm.mediumHeader),
    'content--noheader': !!!_vm.$slots['header']
  }},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }